import { useCallback, useState } from 'react';
import { FlatList, RefreshControl, Text, View } from 'react-native';
import { useFocusEffect } from 'expo-router';
import { useAuth } from '../context/AuthContext';
import { DuplicateDeviceCluster, listDuplicateDevices } from '../api/admin';
import { Card, EmptyState, ErrorText, ScreenContainer } from '../components/ui';
import { colors, fonts } from '../theme';
import { ApiError } from '../api/client';

const ROLE_LABELS: Record<string, string> = {
  REVIEWER: 'Người nhận việc',
  SHOP_OWNER: 'Người đăng việc',
  ADMIN: 'Quản trị viên',
};

export default function AdminDuplicateDevicesScreen() {
  const { token } = useAuth();
  const [clusters, setClusters] = useState<DuplicateDeviceCluster[]>([]);
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      setClusters(await listDuplicateDevices(token));
      setLoadError(null);
    } catch (e) {
      setLoadError(e instanceof ApiError ? e.message : 'Không tải được danh sách thiết bị, vui lòng thử lại.');
    } finally {
      setLoading(false);
    }
  }, [token]);

  useFocusEffect(
    useCallback(() => {
      load();
    }, [load]),
  );

  return (
    <ScreenContainer>
      {loadError ? <ErrorText>{loadError}</ErrorText> : null}
      <FlatList
        data={clusters}
        keyExtractor={(item) => item.deviceFingerprint}
        refreshControl={<RefreshControl refreshing={loading} onRefresh={load} />}
        ListEmptyComponent={!loading && !loadError ? <EmptyState text="Không phát hiện thiết bị nào dùng nhiều tài khoản" /> : null}
        renderItem={({ item }) => (
          <Card>
            <Text style={{ fontSize: 12, color: colors.textMuted, marginBottom: 8 }}>
              Thiết bị: {item.deviceFingerprint}
            </Text>
            {item.users.map((u) => (
              <View
                key={u.id}
                style={{ paddingVertical: 8, borderTopWidth: 1, borderTopColor: colors.border }}
              >
                <Text style={{ fontSize: 15, fontFamily: fonts.bold, color: colors.text }}>{u.name}</Text>
                <Text style={{ color: colors.textMuted, marginTop: 2, fontSize: 13 }}>{u.email}</Text>
                <Text style={{ color: colors.textMuted, marginTop: 2, fontSize: 12 }}>
                  {ROLE_LABELS[u.role] ?? u.role} · Tạo lúc {new Date(u.createdAt).toLocaleString('vi-VN')}
                </Text>
              </View>
            ))}
          </Card>
        )}
      />
    </ScreenContainer>
  );
}
